<span class="content">
    <h2>Welcome to WatchGuard Noida Internal Pipeline</h2>
    <ul class="list">
        <li class="list-item">- Choose <b>Pipeline</b> to go over the pipeline build and logs</li>
        <li class="list-item">- Choose <b>Services</b> to go over the service logs</li>
    </ul>
</span>